import React from "react";
import styles from "../style.module.css";
import { Avatar } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../../../Firebase_config";
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

const Outbox = ({ outboxArray }) => {
  const navigate = useNavigate();
  function formatCustomDate(timestamp) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const dateObjUTC = new Date(timestamp);
    const dateObjIST = new Date(dateObjUTC.getTime() + 5.5 * 60 * 60 * 1000); // Adding 5 hours 30 minutes for IST
    const year = dateObjIST.getUTCFullYear();
    const month = months[dateObjIST.getUTCMonth()];
    const day = dateObjIST.getUTCDate();
    const hours = dateObjIST.getUTCHours();
    const minutes = dateObjIST.getUTCMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    const daySuffix = getDaySuffix(day);
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedDate = `${day}${daySuffix} ${month}, ${year} | ${formattedHours}:${formattedMinutes} ${ampm}`;
    return formattedDate;
  }

  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) {
      return "th";
    }
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
  async function updateMessageSeen(outboxId, chatId) {
    const outboxChatUserRef = collection(db, "outbox", outboxId, "chatUser");

    try {
      const querySnapshot = await getDocs(outboxChatUserRef);

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        if (data.id === chatId) {
          const chatDocRef = doc.ref;
          updateDoc(chatDocRef, {
            sender: true,
          })
            .then(() => {
              console.log("Message updated to msgSeen: true");
            })
            .catch((error) => {
              console.error("Error updating message:", error);
            });
        }
      });
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  }
  function sortMessages(messages) {
    const unseenMessages = messages.filter((message) => !message.sender);
    const seenMessages = messages.filter((message) => message.sender);

    return [...unseenMessages, ...seenMessages];
  }
  function truncateText(text, maxLength = 15) {
    if (text.length > maxLength) {
      return text.slice(0, maxLength) + ".......";
    }
    return text;
  }

  return (
    <div className={styles.tableDiv}>
      <TableContainer
        style={{ border: "1px solid #D9E1E7", borderRadius: "20px" }}
      >
        <Table variant="simple">
          <Thead>
            <Tr>
            
              <Th style={{ textTransform:"capitalize" }}>Subject</Th>
              <Th style={{ textTransform:"capitalize" }}>Message Body</Th>
              <Th style={{ textTransform:"capitalize" }}>Date & Time</Th>
            </Tr>
          </Thead>
          <Tbody>
            {sortMessages(outboxArray).map((el, i) => (
              <Tr
                key={i}
                onClick={() => {
                  updateMessageSeen(el.from, el.id).then(() => {
                    navigate(
                      `/Messages/Chat/${el.to}?inbox=false&chatId=${el.id}`
                    );
                  });
                }}
                className={!el.sender && styles.unseen}
              >
               
                <Td>{truncateText(el?.subject)}</Td>
                <Td>{truncateText(el?.Msg)}</Td>
                <Td>{formatCustomDate(el?.timestamp)}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Outbox;
